var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "regist mailSetting" }, [
    _vm.showLoading ? _c("div", { staticClass: "jleague_loader" }) : _vm._e(),
    _vm._v(" "),
    !_vm.showLoading
      ? _c("div", [
          _vm.selectedClubTeam
            ? _c("h2", [
                _c("img", {
                  attrs: {
                    src: _vm.emblemImagePath(_vm.selectedClubTeam().emblemImg),
                    alt: "",
                  },
                }),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.selectedClubTeam().teamName) +
                    "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.filteredPlayerList.length > 0
            ? _c(
                "div",
                _vm._l(
                  _vm.selectedPlayerIds,
                  function (selectedPlayerId, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "player-selection" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v(_vm._s(index + 1) + "人目"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "select player-select expanded" },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedPlayerIds[index],
                                    expression: "selectedPlayerIds[index]",
                                  },
                                ],
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.selectedPlayerIds,
                                        index,
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    _vm.onPlayerChange,
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "null" } }, [
                                  _vm._v("未設定"),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.filteredPlayerList,
                                  function (player) {
                                    return _c(
                                      "option",
                                      {
                                        key: player.player_id,
                                        attrs: {
                                          disabled:
                                            _vm.isPlayerSelected(
                                              player.player_id
                                            ) &&
                                            !_vm.isCurrentSelection(
                                              player.player_id,
                                              index
                                            ),
                                        },
                                        domProps: { value: player.player_id },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(player.position) +
                                            " " +
                                            _vm._s(player.uniform_number) +
                                            " " +
                                            _vm._s(player.player_name) +
                                            "\n                        "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]
                    )
                  }
                ),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "btnSpace duo" }, [
            _c(
              "button",
              {
                staticClass: "return",
                attrs: { type: "button" },
                on: { click: _vm.goToClubSelection },
              },
              [_vm._v("クラブ選択に戻る")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                attrs: { type: "submit", disabled: _vm.isUpdating },
                on: { click: _vm.updateFavoritePlayers },
              },
              [_vm._v("登録")]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }